import { Component, Story } from './DocTypes';

const RequiredStory: Story = {
  title: 'Required rule',
  description: 'Required rule',
  coreComponent_v3: {
    html: `<tag3-validator source-element='.some-input' source-element-value-prop='value' trigger-element-event='focusout' rule='required' error-element='.some-input-error'></tag3-validator>
    <tag3-input placeholder='Enter something ...' class='some-input'></tag3-input>
    <tag3-validation-alert class='some-input-error'>You must enter something</tag3-validation-alert>`,
  },
  reactWrapper_v3: {
    jsx: `<>
      <Tag3Validator sourceElement='.some-input' sourceElementValueProp='value' triggerElementEvent='focusout' rule='required' errorElement='.some-input-error' />
      <Tag3Input placeholder='Enter something ...' className='some-input' />
      <Tag3ValidationAlert className='some-input-error'>You must enter something</Tag3ValidationAlert>
    </>`,
  },
};

const EmailStory: Story = {
  title: 'Email rule',
  description: 'Email rule',
  coreComponent_v3: {
    html: `<tag3-validator source-element='.some-input' source-element-value-prop='value' rule='email' trigger-element-event='focusout' error-element='.some-input-error'></tag3-validator>
    <tag3-input placeholder='Enter an email address' class='some-input'></tag3-input>
    <tag3-validation-alert class='some-input-error'>You must enter an email address</tag3-validation-alert>
    `,
  },
  reactWrapper_v3: {
    jsx: `<>
    <Tag3Validator sourceElement='.some-input' sourceElementValueProp='value' rule='email' triggerElementEvent='focusout' errorElement='.some-input-error'></Tag3Validator>
    <Tag3Input placeholder='Enter an email address' className='some-input'></Tag3Input>
    <Tag3ValidationAlert className='some-input-error'>You must enter an email address</Tag3ValidationAlert>
    </>`,
  },
};

const LengthStory: Story = {
  title: 'Length rule',
  description: 'Length rule',
  coreComponent_v3: {
    html: `<div style='display:flex;justify-content:space-between'>
  <div>
    <tag3-label>Max Length</tag3-label>
    <tag3-validator source-element='.some-input' source-element-value-prop='value' rule='maxlength' trigger-element-event='focusout' error-element='.some-input-error' args='5'></tag3-validator>
    <tag3-input value='123456' class='some-input'></tag3-input>
    <tag3-validation-alert class='some-input-error'>You must enter maximum 5 characters </tag3-validation-alert>
  </div>
  <div>
    <tag3-label>Min Length</tag3-label>
    <tag3-validator source-element='.some-input-min' source-element-value-prop='value' rule='minlength' trigger-element-event='focusout' error-element='.some-input-error-min' args='5'></tag3-validator>
    <tag3-input value='1234' class='some-input-min'></tag3-input>
    <tag3-validation-alert class='some-input-error-min'>You must enter at least 5 characters</tag3-validation-alert>
  </div>
</div>
    `,
  },
  reactWrapper_v3: {
    jsx: `<div style={{display:'flex',justifyContent:'space-between'}}>
  <div>
    <Tag3Label>Max Length</Tag3Label>
    <Tag3Validator sourceElement='.some-input'  sourceElementValueProp='value' rule='maxlength' args={5} triggerElementEvent='focusout' errorElement='.some-input-error'></Tag3Validator>
    <Tag3Input value='123456' className='some-input'></Tag3Input>
    <Tag3ValidationAlert className='some-input-error'>You must enter maximum 5 characters</Tag3ValidationAlert>
  </div>
  <div>
    <Tag3Label>Min Length</Tag3Label>
    <Tag3Validator sourceElement='.some-input-min'  sourceElementValueProp='value' rule='minlength' args={5}  triggerElementEvent='focusout' errorElement='.some-input-error-min'></Tag3Validator>
    <Tag3Input value='1234' className='some-input-min'></Tag3Input>
    <Tag3ValidationAlert className='some-input-error-min'>You must enter at least 5 characters</Tag3ValidationAlert>
  </div>
</div>`,
  },
};

const UrlStory: Story = {
  title: 'Url rule',
  description: 'Url rule',
  coreComponent_v3: {
    html: `<tag3-validator source-element='.some-input' source-element-value-prop='value' rule='url' trigger-element-event='focusout' error-element='.some-input-error'></tag3-validator>
    <tag3-input placeholder='Enter an url' class='some-input'></tag3-input>
    <tag3-validation-alert class='some-input-error'>You must enter an url</tag3-validation-alert>`,
  },
  reactWrapper_v3: {
    jsx: `<>
    <Tag3Validator sourceElement='.some-input'  sourceElementValueProp='value' rule='url' triggerElementEvent='focusout' errorElement='.some-input-error'></Tag3Validator>
    <Tag3Input placeholder='Enter an url' className='some-input'></Tag3Input>
    <Tag3ValidationAlert className='some-input-error'>You must enter an url</Tag3ValidationAlert>
    </>`,
  },
};

const ArrayStory: Story = {
  title: 'Array rule',
  description: 'Array rule',
  coreComponent_v3: {
    html: `<div style='display:flex;justify-content:space-between'>
  <div>
    <tag3-label>In Array</tag3-label>
    <tag3-validator source-element='.some-input' source-element-value-prop='value' rule='inarray' trigger-element-event='focusout' error-element='.some-input-error' args=[1,2,3,4]></tag3-validator>
    <tag3-input value='7' class='some-input'></tag3-input>
    <tag3-validation-alert class='some-input-error'>This is not a valid value from array [1,2,3,4]</tag3-validation-alert>
  </div>
  <div>
    <tag3-label>Not In Array</tag3-label>
    <tag3-validator source-element='.some-input-not' source-element-value-prop='value' rule='notinarray' trigger-element-event='focusout' error-element='.some-input-error-not' args=[1,2,3,4]></tag3-validator>
    <tag3-input value='3' class='some-input-not'></tag3-input>
    <tag3-validation-alert class='some-input-error-not'>This value can be found in array [1,2,3,4]</tag3-validation-alert>
  </div>
</div>`,
  },
  reactWrapper_v3: {
    jsx: `<div style={{display:'flex',justifyContent:'space-between'}}>
  <div>
    <Tag3Label>In array</Tag3Label>
    <Tag3Validator sourceElement='.some-input'  sourceElementValueProp='value' rule='inarray' triggerElementEvent='focusout' errorElement='.some-input-error' args='[1,2,3,4]'></Tag3Validator>
    <Tag3Input value='7' className='some-input'></Tag3Input>
    <Tag3ValidationAlert className='some-input-error'>This is not a valid value from array [1,2,3,4]</Tag3ValidationAlert>
  </div>
  <div>
    <Tag3Label>Not in array</Tag3Label>
    <Tag3Validator sourceElement='.some-input-not'  sourceElementValueProp='value' rule='notinarray' triggerElementEvent='focusout' errorElement='.some-input-error-not'  args='[1,2,3,4]'></Tag3Validator>
    <Tag3Input value='3' className='some-input-not'></Tag3Input>
    <Tag3ValidationAlert className='some-input-error-not'>This value can be found in array [1,2,3,4]</Tag3ValidationAlert>
  </div>
</div>`,
  },
};

const MatchStory: Story = {
  title: 'Matches rule',
  description: 'Matches rule',
  coreComponent_v3: {
    html: `<tag3-label>Enter something</tag3-h3>
    <tag3-validator source-element='.some-input' source-element-value-prop='value' rule='matches' trigger-element-event='focusout' error-element='.some-input-error' args="spain":></tag3-validator>
    <tag3-input value="This is france" class='some-input'></tag3-input>
    <tag3-validation-alert class='some-input-error'>This is not the correct format. It should contain the word 'spain'.</tag3-validation-alert>`,
  },
  reactWrapper_v3: {
    jsx: `
    <div>
      <Tag3Label>Enter something</Tag3Label>
      <Tag3Validator sourceElement='.some-input' rule='matches' triggerElementEvent='focusout' errorElement='.some-input-error' args='spain'></Tag3Validator>
      <Tag3Input value='This is france' className='some-input'></Tag3Input>
      <Tag3ValidationAlert className='some-input-error'>This is not the correct format. It should contain the word 'spain'.</Tag3ValidationAlert>
    </div>`,
  },
};

const RegexStory: Story = {
  title: 'Regex rule',
  description: 'Regex rule',
  coreComponent_v3: {
    html: `<tag3-validator source-element='.some-input' source-element-value-prop='value' rule='matches' trigger-element-event='focusout' error-element='.some-input-error' args='^[0-9]{6}$':></tag3-validator>
    <tag3-input value="12345" class='some-input'></tag3-input>
    <tag3-validation-alert class='some-input-error'>This is not the correct format</tag3-validation-alert>`,
  },
  reactWrapper_v3: {
    jsx: `
    <div>
      <Tag3H3> Regex rule </Tag3H3>
      <Tag3Validator sourceElement='.some-input'  sourceElementValueProp='value' rule='matches' triggerElementEvent='focusout' errorElement='.some-input-error' args='^[0-9]{6}$'></Tag3Validator>
      <Tag3Input value='12345' className='some-input'></Tag3Input>
      <Tag3ValidationAlert className='some-input-error'>This is not the correct format</Tag3ValidationAlert>
    </div>`,
  },
};

const GreaterLessStory: Story = {
  title: 'Greater/Less then rules',
  description: 'Greater/Less then rules',
  coreComponent_v3: {
    html: `<div style='display:flex;justify-content:space-between'>
  <div>
    <tag3-label> Greater than </tag3-label>
    <tag3-validator source-element='.some-input-greater' source-element-value-prop='value' rule='greaterthan' trigger-element-event='focusout' error-element='.some-input-error-greater' args='5'></tag3-validator>
    <tag3-input value="5" class='some-input-greater'></tag3-input>
    <tag3-validation-alert class='some-input-error-greater'>This value needs to be greater than 5</tag3-validation-alert>
  </div>
  <div>
    <tag3-label> Greater than or equal to </tag3-label>
    <tag3-validator source-element='.some-input-greater-equal' source-element-value-prop='value' rule='greaterthanorequalto' trigger-element-event='focusout' error-element='.some-input-error-greater-equal' args='5'></tag3-validator>
    <tag3-input value="4" class='some-input-greater-equal'></tag3-input>
    <tag3-validation-alert class='some-input-error-greater-equal'>This value needs to be greater or equal to 5</tag3-validation-alert>
  </div>
  <div>
    <tag3-label> Less than </tag3-label>
    <tag3-validator source-element='.some-input-less' source-element-value-prop='value' rule='lessthan' trigger-element-event='focusout' error-element='.some-input-error-less' args='5'></tag3-validator>
    <tag3-input value="5" class='some-input-less'></tag3-input>
    <tag3-validation-alert class='some-input-error-less'>This value needs to be less than 5</tag3-validation-alert>
  </div>
  <div>
    <tag3-label> Less than or equal to </tag3-label>
    <tag3-validator source-element='.some-input-less-equal' source-element-value-prop='value' rule='lessthanorequalto' trigger-element-event='focusout' error-element='.some-input-error-less-equal' args='5'></tag3-validator>
    <tag3-input value="6" class='some-input-less-equal'></tag3-input>
    <tag3-validation-alert class='some-input-error-less-equal'>This value needs to be less or equal to 5</tag3-validation-alert>
  </div>
</div>`,
  },
  reactWrapper_v3: {
    jsx: `<div style={{display:'flex',justifyContent:'space-between'}}>
      <div>
        <Tag3Label> Greater than </Tag3Label>
        <Tag3Validator sourceElement='.some-input-greater' sourceElementValueProp='value' rule='greaterthan' triggerElementEvent='focusout' errorElement='.some-input-error-greater' args='5'></Tag3Validator>
        <Tag3Input value="5" className='some-input-greater'></Tag3Input>
        <Tag3ValidationAlert className='some-input-error-greater'>This value needs to be greater than 5</Tag3ValidationAlert>
      </div>
      <div>
        <Tag3Label> Greater than or equal to </Tag3Label>
        <Tag3Validator sourceElement='.some-input-greater-equal'  sourceElementValueProp='value' rule='greaterthanorequalto' triggerElementEvent='focusout' errorElement='.some-input-error-greater-equal'  args='5'></Tag3Validator>
        <Tag3Input value='4' className='some-input-greater-equal'></Tag3Input>
        <Tag3ValidationAlert className='some-input-error-greater-equal'>This value needs to be greater or equal to 5</Tag3ValidationAlert>
      </div>
      <div>
        <Tag3Label> Less than </Tag3Label>
        <Tag3Validator sourceElement='.some-input-less'  sourceElementValueProp='value' rule='lessthan' triggerElementEvent='focusout' errorElement='.some-input-error-less' args='5'></Tag3Validator>
        <Tag3Input value='5' className='some-input-less'></Tag3Input>
        <Tag3ValidationAlert className='some-input-error-less'>This value needs to be less than 5</Tag3ValidationAlert>
      </div>
      <div>
        <Tag3Label> Less than or equal to </Tag3Label>
        <Tag3Validator sourceElement='.some-input-less-equal'  sourceElementValueProp='value' rule='lessthanorequalto' triggerElementEvent='focusout' errorElement='.some-input-error-less-equal'  args='5'></Tag3Validator>
        <Tag3Input value='6' className='some-input-less-equal'></Tag3Input>
        <Tag3ValidationAlert className='some-input-error-less-equal'>This value needs to be less or equal to 5</Tag3ValidationAlert>
      </div>
    </div>`,
  },
};

const HttpStory: Story = {
  title: 'Http response rules',
  description: 'Http response rules',
  coreComponent_v3: {
    html: `<div style='display:flex;justify-content:space-between'>
  <div>
    <tag3-label> In http response </tag3-h3>
    <tag3-validator source-element='.some-input' source-element-value-prop='value' rule='inhttpresponse' trigger-element-event='focusout' error-element='.some-input-error' args='{"path": "https://swapi.dev/api/people/?page=1", "responseBodyArrayProp": "results", "objectProp": "name"}'></tag3-validator>
    <tag3-input value="Luke Vader" class='some-input'></tag3-input>
    <tag3-validation-alert class='some-input-error'> This is not a valid value </tag3-validation-alert>
  </div>
  <div>
    <tag3-label> Not in http response </tag3-h3>
    <tag3-validator source-element='.some-input-not' source-element-value-prop='value' rule='notinhttpresponse' trigger-element-event='focusout' error-element='.some-input-error-not' args='{"path": "https://swapi.dev/api/people/?page=1", "responseBodyArrayProp": "results", "objectProp": "name"}'></tag3-validator>
    <tag3-input value="Luke Skywalker" class='some-input-not'></tag3-input>
    <tag3-validation-alert class='some-input-error-not'> This is not a valid value </tag3-validation-alert>
  </div>
</div>`,
  },
  reactWrapper_v3: {
    jsx: `<div style={{display:'flex',justifyContent:'space-between'}}>
      <div>
        <Tag3Label> In http response </Tag3Label>
        <Tag3Validator sourceElement='.some-input'  sourceElementValueProp='value' rule='inhttpresponse' triggerElementEvent='focusout' errorElement='.some-input-error' args='{"path": "https://swapi.dev/api/people/?page=1", "responseBodyArrayProp": "results", "objectProp": "name"}'></Tag3Validator>
        <Tag3Input value='Luke Vader' className='some-input'></Tag3Input>
        <Tag3ValidationAlert className='some-input-error'>This is not a valid value</Tag3ValidationAlert>
      </div>
      <div>
        <Tag3Label> Not in http response </Tag3Label>
        <Tag3Validator sourceElement='.some-input-not'  sourceElementValueProp='value' rule='notinhttpresponse' triggerElementEvent='focusout' errorElement='.some-input-error-not'  args='{"path": "https://swapi.dev/api/people/?page=1", "responseBodyArrayProp": "results", "objectProp": "name"}'></Tag3Validator>
        <Tag3Input value='Luke Skywalker' className='some-input-not'></Tag3Input>
        <Tag3ValidationAlert className='some-input-error-not'>This is not a valid value</Tag3ValidationAlert>
      </div>
    </div>`,
  },
};

const DateRangeStory: Story = {
  title: 'Date range rules',
  description: 'Whether date is within certain bounds',
  coreComponent_v3: {
    html: `<div style='display:flex;justify-content:space-between'>
  <div style='display:flex; align-items:center;'>
    <tag3-label>Greater than 20/03/2025</tag3-label>
    <tag3-validator source-element='.some-input-greater' source-element-value-prop='value' rule='greaterthan' trigger-element-event='datePickerValueChange' error-element='.some-input-error-greater' args='20/03/2025' type='date'></tag3-validator>
    <tag3-date-picker class='some-input-greater'></tag3-date-picker>
    <tag3-validation-alert class='some-input-error-greater'>This value needs to be greater than 20/03/2025</tag3-validation-alert>
  </div>
  <div style='display:flex; align-items:center;'>
    <tag3-label>Less than 20/03/1975</tag3-label>
    <tag3-validator source-element='.some-input-less' source-element-value-prop='value' rule='lessthan' trigger-element-event='datePickerValueChange' error-element='.some-input-error-less' args='20/03/1975' type='date'></tag3-validator>
    <tag3-date-picker class='some-input-less'></tag3-date-picker>
    <tag3-validation-alert class='some-input-error-less'>This value needs to be less than 20/03/1975</tag3-validation-alert>
  </div>
</div>`,
  },
  reactWrapper_v3: {
    jsx: `
    <div style={{display:'flex',justifyContent:'space-between'}}>
      <div style={{display:'flex',alignItems:'center'}}>
        <Tag3Label>Greater than date 20/03/2025</Tag3Label>
        <Tag3Validator sourceElement='.some-input-greater'  sourceElementValueProp='value' rule='greaterthan' triggerElementEvent='datePickerValueChange' errorElement='.some-input-error-greater' args='20/03/2025' type='date'></Tag3Validator>
        <Tag3DatePicker className='some-input-greater'></Tag3DatePicker>
        <Tag3ValidationAlert className='some-input-error-greater'>This value needs to be greater than 20/03/2025</Tag3ValidationAlert>
      </div>
      <div style={{display:'flex',alignItems:'center'}}>
        <Tag3Label>Less than date 20/03/1975</Tag3Label>
        <Tag3Validator sourceElement='.some-input-less'  sourceElementValueProp='value' rule='lessthan' triggerElementEvent='datePickerValueChange' errorElement='.some-input-error-less' args='20/03/1975' type='date'></Tag3Validator>
        <Tag3DatePicker className='some-input-less'></Tag3DatePicker>
        <Tag3ValidationAlert className='some-input-error-less'>This value needs to be less than 20/03/1975</Tag3ValidationAlert>
      </div>
    </div>`,
  },
};

const CustomStory: Story = {
  title: 'Custom rule',
  description: 'Custom rule',
  coreComponent_v3: {
    html: `<tag3-validator source-element='.some-input' source-element-value-prop='value' trigger-element-event='focusout' error-element='.some-input-error'></tag3-validator>
<tag3-input placeholder="Enter something" class='some-input'></tag3-input>
<tag3-validation-alert class='some-input-error'>You must enter FRED</tag3-validation-alert>`,
    js: `var tagValidation = document.querySelector('tag3-validator');
      tagValidation.rule = function(value, args, type) {
        return value === 'FRED' ? true : false;
      };`,
  },
  reactWrapper_v3: {
    jsx: `
    <div>
      <Tag3Validator sourceElement='.some-input'  sourceElementValueProp='value' triggerElementEvent='focusout' errorElement='.some-input-error' rule = {(value, args) =>
      value === 'FRED' ? true : false}></Tag3Validator>
      <Tag3Input placeholder='Enter something' className='some-input'></Tag3Input>
      <Tag3ValidationAlert className='some-input-error'>You must enter FRED</Tag3ValidationAlert>
    </div>
    `,
  },
};

const MultipleValidationStory: Story = {
  title: 'Multiple validation',
  description: 'An example of form with a field that is validated with multiple rules',
  coreComponent_v3: {
    html: `
    <div>
      <tag3-validator source-element='.some-input' source-element-value-prop='value' rule='email' trigger-element-event='focusout' error-element='.some-input-error'></tag3-validator>
      <tag3-validator source-element='.some-input' source-element-value-prop='value' rule='minlength' trigger-element-event='focusout' error-element='.some-input-error' args='10'></tag3-validator>
      <tag3-input placeholder="Enter something" class='some-input'></tag3-input>
      <tag3-validation-alert class='some-input-error'>You must enter an email adress with at least 10 characters</tag3-validation-alert>
    </div>`,
  },
  reactWrapper_v3: {
    jsx: `
    <div>
      <Tag3Validator sourceElement='.some-input' sourceElementValueProp='value' rule='email' triggerElementEvent='focusout' errorElement='.some-input-error'></Tag3Validator>
      <Tag3Validator sourceElement='.some-input' sourceElementValueProp='value' rule='minlength' triggerElementEvent='focusout' errorElement='.some-input-error' args='10'></Tag3Validator>
      <Tag3Input placeholder='Enter something' className='some-input'></Tag3Input>
      <Tag3ValidationAlert className='some-input-error'>You must enter an accessgroup email adress with at least 10 characters</Tag3ValidationAlert>
    </div>`,
  },
};

const ProgrammaticValidationStory: Story = {
  title: 'Programmatic Validation',
  description: 'An example of form with 2 fields that are validated on submit button click',
  coreComponent_v3: {
    html: `
    <tag-form submit-button-hidden="true">
      <tag-form-group>
        <tag3-p>Name: </tag3-p>
        <tag3-validator
          source-element='.some-input'
          source-element-value-prop='value'
          rule='required'
          error-element='.some-input-error'
          trigger-element-event='focusout'>
        </tag3-validator>
        <tag3-input placeholder="Enter name" class='some-input'></tag3-input>
        <tag3-validation-alert class='some-input-error'>You must enter your name</tag3-validation-alert>
      </tag-form-group>
      <tag-form-group>
        <tag3-p>Email: </tag3-p>
        <tag3-validator 
          source-element='.some-input2'
          source-element-value-prop='value'
          rule='email'
          error-element='.some-input-error2'
          trigger-element-event='focusout'>
        </tag3-validator>
        <tag3-input placeholder="Enter email" class='some-input2'></tag3-input>
        <tag3-validation-alert class='some-input-error2'>You must enter a valid email</tag3-validation-alert>
      </tag-form-group>
    </tag-form>

    <tag3-button size='large' icon='Save' accent="viridiangreen" text='Submit' icon-accent='white' class='submit-button'></tag3-button>
    <tag3-label style="display:none" accent="viridiangreen">Submitted<tag3-label>
    `,
    js: `
    var validators = document.querySelectorAll('tag3-validator');
    var button = document.querySelector('tag3-button');
    var form = document.querySelector('tag-form');
    var label = document.querySelector('tag3-label')
    button.addEventListener('buttonClick',async function() {
      const promises = [...validators].map(validator => {return validator.validate();})
      Promise.all(promises).then((values) => {values.includes(false) ? label.style = "display:none" : form.submitForm()})
    });
    document.addEventListener('submit', event => {   
      label.style = "display:inline-block";
    })
    `,
  },
  reactWrapper_v3: {
    parentJSX: `
    Example = () => {
      const coreComponent1 = React.useRef(null);
      const coreComponent2 = React.useRef(null);
      const labelComponent = React.useRef(null);
      const formComponent = React.useRef(null);
      const [displayLabel, setDisplayLabel] = React.useState("none");
      return (
        <div>
          <TagForm 
          ref={formComponent} 
          submitButtonHidden="true"
          onSubmit = { () => {
            setDisplayLabel("inline-block");
          }}>
            <TagFormGroup>
              <Tag3P>Name: </Tag3P>
              <Tag3Validator
                ref={coreComponent1}
                sourceElement='.some-input'
                sourceElement-value-prop='value'
                rule='required'
                errorElement='.some-input-error'
                triggerElementEvent='focusout'>
              </Tag3Validator>
              <Tag3Input placeholder="Enter name" className='some-input'></Tag3Input>
              <Tag3ValidationAlert className='some-input-error'>You must enter your name</Tag3ValidationAlert>
            </TagFormGroup>
            <TagFormGroup>
              <Tag3P>Email: </Tag3P>
              <Tag3Validator
                ref={coreComponent2}
                sourceElement='.some-input2'
                sourceElement-value-prop='value'
                rule='email'
                errorElement='.some-input-error2'
                triggerElementEvent='focusout'>
              </Tag3Validator>
              <Tag3Input placeholder="Enter email" className='some-input2'></Tag3Input>
              <Tag3ValidationAlert className='some-input-error2'>You must enter a valid email</Tag3ValidationAlert>
            </TagFormGroup>
          </TagForm>

          <Tag3Button size='large' icon='Save' accent="viridiangreen" text='Submit' iconAccent='white'
            onButtonClick={async () => {
              const res = await coreComponent1.current.validate(); 
              const res2 = await coreComponent2.current.validate();
              res && res2 ? formComponent.current.tagComponent.current.submitForm() : setDisplayLabel("none");
            }}
          ></Tag3Button>
          <Tag3Label ref={labelComponent} textStyle={{display:displayLabel}} accent="viridiangreen">Submitted</Tag3Label>
        </div>
      )
    };
    `,
    jsx: `<Example />`,
  },
};

const BlurStory: Story = {
  title: 'Validate on blur',
  description: 'Required rule',
  coreComponent_v3: {
    html: `<tag3-label>Entity Name</tag3-label>
    <tag3-input name="entityName"></tag3-input>
    <tag3-validator
      source-element="tag3-input[name='entityName'] input"
      source-element-value-prop="value"
      trigger-element-event="blur"
      rule="required"
      error-element=".entityName-input-error"
    ></tag3-validator>
    <tag3-validation-alert class="entityName-input-error">
       You must enter the entity name
    </tag3-validation-alert>`,
  },
  reactWrapper_v3: {
    jsx: `<>
      <Tag3Label>Entity Name</Tag3Label>
      <Tag3Input name="entityName"/>
      <Tag3Validator 
        sourceElement="tag3-input[name='entityName'] input"
        sourceElementValueProp='value'
        triggerElementEvent='blur'
        rule='required' 
        errorElement='.entityName-input-error' />
      <Tag3ValidationAlert className='entityName-input-error'>
        You must enter the entity name
      </Tag3ValidationAlert>
    </>`,
  },
};

const MobileStory: Story = {
  title: 'Mobile input validation',
  description: 'Validation style when applied to mobile inputs',
  coreComponent_v3: {
    html: `
<tag3-input name="inputEntity" device="mobile" placeholder="Don't enter a value..." style="display:block"></tag3-input>
<tag3-validator
  source-element="tag3-input[name='inputEntity'] input"
  source-root-element="tag3-input[name='inputEntity']"
  source-element-value-prop="value"
  trigger-element-event="blur"
  rule="required"
  error-element=".inputEntity-input-error"
></tag3-validator>
<tag3-validation-alert class="inputEntity-input-error" device="mobile">
    You must enter a value to hide this
</tag3-validation-alert>
<br />
<tag3-mobile-date-time-input placeholder="Don't enter a date..." name="dateEntity" formatting-options='ddd, DD-MMM-YYYY'></tag3-mobile-date-time-input>
<tag3-validator
  source-element="tag3-mobile-date-time-input[name='dateEntity'] input"
  source-root-element="tag3-mobile-date-time-input[name='dateEntity']"
  source-element-value-prop="value"
  trigger-element-event="blur"
  rule="required"
  error-element=".dateEntity-input-error"
></tag3-validator>
<tag3-validation-alert class="dateEntity-input-error" device="mobile">
    You must enter a value to hide this
</tag3-validation-alert>
<br />
<tag3-mobile-dropdown name="dropdownEntity" placeholder="Don't enter a colour..."></tag3-mobile-dropdown>
<tag3-validator
  source-element="tag3-mobile-dropdown[name='dropdownEntity'] select"
  source-root-element="tag3-mobile-dropdown[name='dropdownEntity']"
  source-element-value-prop="value"
  trigger-element-event="blur"
  rule="required"
  error-element=".dropdownEntity-input-error"
></tag3-validator>
<tag3-validation-alert class="dropdownEntity-input-error" device="mobile">
    You must enter a value to hide this
</tag3-validation-alert>
`,
    js: `var dropdown = document.querySelector("tag3-mobile-dropdown");
dropdown.data = [
  { label: "Choose a colour...", value: "" },
  { label: "Red", value: 1 },
  { label: "Blue", value: 2 },
  { label: "Green", value: 3 },
];`,
  },
  reactWrapper_v3: {
    jsx: `<>
  <Tag3Input name="inputEntity" device="mobile" placeholder="Don't enter a value..." style={{"display":"block"}} />
  <Tag3Validator 
    sourceElement="tag3-input[name='inputEntity'] input"
    sourceRootElement="tag3-input[name='inputEntity']"
    sourceElementValueProp='value'
    triggerElementEvent='blur'
    rule='required' 
    errorElement='.inputEntity-input-error' />
  <Tag3ValidationAlert className='inputEntity-input-error' device="mobile">
    You must enter a value to hide this
  </Tag3ValidationAlert>
  <br />
  <TagMobileDateTimeInput name="dateEntity" placeholder="Don't enter a date..." formattingOptions='ddd, DD-MMM-YYYY' />
  <Tag3Validator 
    sourceElement="tag3-mobile-date-time-input[name='dateEntity'] input"
    sourceRootElement="tag3-mobile-date-time-input[name='dateEntity']"
    sourceElementValueProp='value'
    triggerElementEvent='blur'
    rule='required' 
    errorElement='.dateEntity-input-error' />
  <Tag3ValidationAlert className='dateEntity-input-error' device="mobile">
    You must enter a value to hide this
  </Tag3ValidationAlert>
  <br />
  <TagMobileDropDown 
    name="dropdownEntity" 
    placeholder="Don't enter a colour..." 
    data={[
      { label: "Choose a colour...", value: "" },
      { label: "Red", value: 1 },
      { label: "Blue", value: 2 },
      { label: "Green", value: 3 },
    ]}
  />
  <Tag3Validator 
    sourceElement="tag3-mobile-dropdown select"
    sourceRootElement="tag3-mobile-dropdown[name='dropdownEntity']"
    sourceElementValueProp='value'
    triggerElementEvent='blur'
    rule='required' 
    errorElement='.dropdownEntity-input-error' />
  <Tag3ValidationAlert className='dropdownEntity-input-error' device="mobile">
    You must enter a value to hide this
  </Tag3ValidationAlert>
</>`,
  },
};

export const TagValidatorDocs: Component = {
  type: 'component',
  name: 'validator',
  description: 'Enables validation on any HTML element',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'sourceElement',
      description: 'CSS selector for the element to validate',
      type: 'string',
    },
    {
      name: 'sourceRootElement',
      description:
        'Optional CSS selector for the main TAG element to validate. To be used when the sourceElement is not the root element, to ensure invalid styling applies',
      type: 'string',
    },
    {
      name: 'sourceElementValueProp',
      description: 'Property name on the source element that will retrieve its value',
      type: 'string',
    },
    {
      name: 'triggerElement',
      description: 'CSS selector for the element that triggers the validation',
      type: 'string',
      default: 'sourceElement',
    },
    {
      name: 'triggerElementEvent',
      description: 'Native event name on the trigger element that will trigger validation',
      type: 'string',
    },
    {
      name: 'rule',
      description: 'The validation rule',
      type:
        'required | email | url | maxlength | minlength | inarray | notinarray | matches | greaterthan | greaterthanorequalto | lessthan | lessthanorequalto | inhttpresponse | notinhttpresponse',
    },
    {
      name: 'args',
      description: 'The argument for the validation rule',
      type: 'any',
    },
    {
      name: 'errorElement',
      description: 'CSS selector for the element that shows the error message',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'validatorEvent',
      description: 'Triggers when the validation is done',
      parameters: [
        { name: 'value', description: 'True if valid, false if not valid', type: 'boolean' },
      ],
    },
  ],
  methods: [
    {
      name: 'validate',
      description: 'Explicitly triggers the validation rule',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [
    RequiredStory,
    EmailStory,
    UrlStory,
    LengthStory,
    ArrayStory,
    MatchStory,
    RegexStory,
    GreaterLessStory,
    HttpStory,
    DateRangeStory,
    CustomStory,
    MultipleValidationStory,
    ProgrammaticValidationStory,
    BlurStory,
    MobileStory,
  ],
};
